import styled from 'styled-components';
import { FONT_SIZE_6, FONT_WEIGHT_BOLD, MAIN_COLOR, GRAY_LIGHTER } from '../../../styles/variables';
import { flexPosition, fontStyle } from '../../../styles/mixins';

export const ItemWrapper = styled.li`
  ${fontStyle(MAIN_COLOR, FONT_SIZE_6, FONT_WEIGHT_BOLD)}
  list-style: none;
`;

export const Button = styled.button`
  margin-left: auto;
  cursor: pointer;
  border: none;
  background: transparent;
  outline: none;
`;

export const Text = styled.p`
  margin: 0;
`;

export const SubItemWrapper = styled.div`
  display: ${props => (props.isOpen ? 'block' : 'none')};
  transition: all 0.4s;
  overflow: hidden;
`;

export const TitleAccordion = styled.div`
  width: 100%;
  padding: 15px;
  ${flexPosition({ align: 'center', justify: 'flex-start' })}
  border-bottom: 1px solid ${GRAY_LIGHTER};
`;



// WEBPACK FOOTER //
// ./src/components/GenericSelectList/Accordion/style.js